<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="role">{{ 'ROLES.ROLES_FORM.EDIT' | translate }}</span>
    <span *ngIf="!role">{{ 'ROLES.ROLES_FORM.ADD' | translate }}</span>
  </h4>
  <div>
    <button type="button" class="btn btn-xs btn-outline-primary" aria-label="Close" (click)="markAll(true)">
      {{ 'ROLES.ROLES_FORM.SELECT_ALL' | translate }}
    </button>
    <button type="button" class="btn btn-xs btn-outline-danger" aria-label="Close" (click)="markAll(false)">
      {{ 'ROLES.ROLES_FORM.UNSELECT_ALL' | translate }}
    </button>
    <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="role-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="form-group">
      <label>{{ 'ROLES.ROLES_FORM.NAME' | translate }}</label>
      <input type="text" class="form-control" formControlName="name" />
    </div>

    <div formArrayName="groups">
      <div
        *ngFor="let group of form.get('groups')?.controls; let i = index"
        class="single-permission"
        [ngClass]="{ striped: i % 2 == 0 }"
      >
        <div [formGroupName]="i">
          <div class="header d-flex justify-content-between">
            <!--<a (click)="click(group)">debug</a>-->
            <div class="permission-name">
              {{ 'ROLES.ROLES_FORM.PERMISSION_GROUP_' + group.get('group').value | uppercase | translate }}
            </div>
            <div class="permission-buttons">
              <button type="button" class="btn btn-xs btn-primary" (click)="markGroup(group, true)">
                {{ 'ROLES.ROLES_FORM.SELECT_ALL_FROM_GROUP' | translate }}
              </button>
              <button type="button" class="btn btn-xs btn-danger" (click)="markGroup(group, false)">
                {{ 'ROLES.ROLES_FORM.UNSELECT_ALL_FROM_GROUP' | translate }}
              </button>
            </div>
          </div>

          <div class="permission-actions">
            <div formArrayName="permissions" class="row">
              <div *ngFor="let permission of group.get('permissions')?.controls; let j = index" class="col-sm-3">
                <div [formGroupName]="j">
                  <!--<a (click)="click(permission)">debug</a>-->

                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      [attr.id]="'permission' + '-' + permission.get('id').value"
                      [formControl]="permission.get('selected')"
                    />
                    <label class="custom-control-label" [attr.for]="'permission' + '-' + permission.get('id').value">
                      {{ 'ROLES.ROLES_FORM.PERMISSION_' + permission.get('name').value | uppercase | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div (click)="click(form.get('permission')?.controls)">cccc</div>-->
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="role-form" [disabled]="form.invalid">
    {{ 'ROLES.ROLES_FORM.SAVE' | translate }}
  </button>
</div>
